import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@/components/theme-provider';
import { ScrollToTop } from '@/components/scroll-to-top';
import { Navbar } from '@/components/shared/navbar';
import { Footer } from '@/components/shared/footer';
import { HomePage } from '@/pages/home';
import { FeaturesPage } from '@/pages/features';
import { DemoPage } from '@/pages/demo';
import { DevelopersPage } from '@/pages/developers';
import { PricingPage } from '@/pages/pricing';
import { SecurityPage } from '@/pages/security';
import { FaqPage } from '@/pages/faq';
import { ContactPage } from '@/pages/contact';
import '@/styles/index.css';
import '@/styles/pathfinder.css';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ThemeProvider defaultTheme="light" storageKey="naivana-ui-theme-rebrand">
        <div className="flex flex-col min-h-screen">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/features" element={<FeaturesPage />} />
              <Route path="/demo" element={<DemoPage />} />
              <Route path="/developers" element={<DevelopersPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/security" element={<SecurityPage />} />
              <Route path="/faq" element={<FaqPage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </ThemeProvider>
    </BrowserRouter>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
